import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import cashierReducer from '../features/cashier/cashierSlice';
import inventoryReducer from '../features/inventory/inventorySlice';
import mutationReducer from '../features/mutations/mutationSlice';
import returnReducer from '../features/returns/returnSlice';
import reportsReducer from '../features/reports/reportsSlice';
import closingReducer from '../features/closing/closingSlice';
import branchReducer from '../features/branch/branchSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    cashier: cashierReducer,
    inventory: inventoryReducer,
    mutations: mutationReducer,
    returns: returnReducer,
    reports: reportsReducer,
    closing: closingReducer,
    branch: branchReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;